import { Image, ProductType } from '@headless-workspace/typings';
import { ValueHelpers } from '@headless-workspace/utils';
import { mapURLToImage } from '../../../../src/client/lib/types';
import { mapProductPriceData, ProductPriceData, PromotionType } from '../types';
import { CapacityFormat } from './CapacityFormat';
import { ProductDetailSetItemDTO } from './ProductDetailSetItemDTO';
import { getPromotionKey } from './ProductDetailValue';
import { extractVariantFormats, mapProductDetailVariant, ProductDetailVariantValue } from './ProductDetailVariantValue';

export type ProductSetItemValue = {
    id: string;
    name: string;
    imageUrl: Image;
    type: ProductType;
    price: number;
    pricePerUnit?: string;
    variants: ProductDetailVariantValue[];
    formats: CapacityFormat[];
    currency: string;
    promotion?: PromotionType;
} & ProductPriceData;

export const mapProductDetailSetItem =
    (currency: string) =>
    (dto: ProductDetailSetItemDTO): ProductSetItemValue => {
        const variants = dto.variants.map((variant) => mapProductDetailVariant(variant, currency));
        const prices = mapProductPriceData(dto, currency);

        return {
            id: dto.id,
            name: dto.name,
            imageUrl: mapURLToImage(dto.imageUrl) ?? { src: '/images/placeholder.png', alt: dto.name },
            type: ProductType[dto.type],
            pricePerUnit: ValueHelpers.mapOptional(dto.pricePerUnit),
            variants,
            formats: extractVariantFormats(variants),
            promotion: getPromotionKey(dto.promotion, prices) as PromotionType,
            ...prices,
        };
    };
